import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DeleteIcon from '@mui/icons-material/Delete';
import { Tooltip } from '@mui/material';

import ConfirmPrompt from '../components/ui/notices/confirmPrompt/ConfirmPrompt';
import { hasRole } from '../utils/userRoles';

import local from './iconStyles.module.css';

const OnDeleteIcon = ({
    onDelete,
    roles = [],
    acceptedRoles = [],
    active = true,
    confirmTwice = false,
    customClass
}) => {
    const [showConfirmPrompt, setShowConfirmPrompt] = useState(false);
    const [showSecondConfirmPrompt, setShowSecondConfirmPrompt] = useState(false);

    const firstConfirmDeleteModalContent = <div>Are you sure you want to delete?</div>;

    const secondConfirmDeleteModalContent = (
        <div className={local.deleteIconSecondModalContent}>
            <div>DETAILS DELETED CANNOT BE RETRIEVED! </div>
            <div>DO YOU CONFIRM DELETION?</div>
        </div>
    );

    const onDeleteClick = (e) => {
        e.stopPropagation();
        setShowConfirmPrompt(true);
    };

    const onConfirmDelete = (e, doDelete) => {
        e.stopPropagation();
        if (doDelete) {
            confirmTwice ? setShowSecondConfirmPrompt(true) : onDelete();
        }
        setShowConfirmPrompt(false);
    };

    const onSecondConfirmDelete = (e, doDelete) => {
        e.stopPropagation();
        if (doDelete) onDelete();
        setShowSecondConfirmPrompt(false);
    };

    if (
        ((acceptedRoles.length === 0 && roles.length === 0) || hasRole(roles, acceptedRoles)) &&
        active
    ) {
        // Can delete
        return (
            <>
                {showConfirmPrompt && (
                    <ConfirmPrompt
                        isOpen={showConfirmPrompt}
                        onCancel={(e) => onConfirmDelete(e, false)}
                        onConfirm={(e) => onConfirmDelete(e, true)}
                        content={firstConfirmDeleteModalContent}
                    />
                )}
                {showSecondConfirmPrompt && (
                    <ConfirmPrompt
                        isOpen={showSecondConfirmPrompt}
                        onCancel={(e) => onSecondConfirmDelete(e, false)}
                        onConfirm={(e) => onSecondConfirmDelete(e, true)}
                        content={secondConfirmDeleteModalContent}
                    />
                )}

                <Tooltip title="Delete" placement="top">
                    <div className={`${local.deleteIcon} ${local[customClass]}`}>
                        <DeleteIcon
                            aria-label="delete-icon"
                            data-testid="delete-icon"
                            onClick={onDeleteClick}
                        />
                    </div>
                </Tooltip>
            </>
        );
    }
    // Can't do any deleting...
    return (
        <div className={`${local.deleteIcon} ${local.disabled} ${local[customClass]}`}>
            <DeleteIcon aria-label="delete-icon" data-testid="delete-icon-disabled" />
        </div>
    );
};

OnDeleteIcon.propTypes = {
    onDelete: PropTypes.func,
    roles: PropTypes.arrayOf(PropTypes.string),
    acceptedRoles: PropTypes.arrayOf(PropTypes.string),
    active: PropTypes.bool,
    confirmTwice: PropTypes.bool,
    customClass: PropTypes.string
};

export default OnDeleteIcon;
